import { ClosedWonQueueSubmissionsDashboardDTO } from '@user/store/dashboard/widgets/closedWonQueueSubmissions/typings'
import * as React from 'react'
import { FC } from 'react'
import { SoldServiceListCard } from '../SoldServiceListCard/SoldServiceListCard'

interface Props {
  opportunities: ClosedWonQueueSubmissionsDashboardDTO[]
}

export const SoldServiceList: FC<Props> = (props) => {
  const { opportunities } = props
  return (
    <>
      {opportunities.map((opportunity, index) => (
        <SoldServiceListCard data={opportunity} key={index} />
      ))}
    </>
  )
}
